import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, Grid, LL_H_C, ModuleFE_Toaster, SimpleListAdapter, TS_DropDown, TS_PropRenderer, TS_Tabs } from '@nu-art/thunderstorm-frontend/index';
import { TS_InputV2 } from '@nu-art/thunderstorm-frontend/components/TS_V2_Input/TS_InputV2';
import { exists } from '@nu-art/ts-common';
import { QScrollWrapper } from '@app/hcs-frontend';
import './Editor_Organization_Environments.scss';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { DefaultEditor_InputText } from '@app/styles/frontend/ui-manager/ui-components';
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/components/TS_EditableItemComponent/TS_EditableItemComponent';
import { ViewKey_Edit, ViewKey_View } from '../../../consts.js';
import { Editor_EnvironmentConfig } from './Editor_EnvironmentConfig/Editor_EnvironmentConfig.js';
import { Editor_DeployDemoPatient } from './Editors_Patients/Editor_DeployDemoPatient/index.js';
import { Editor_EpicDemoPatient } from './Editors_Patients/Editor_EpicDemoPatient/index.js';
import { ICONS } from '@app/styles';
import { EHRInstallation_TypeLabelMap, EHRInstallationTypes } from '@app/org-shared';
import { ModuleFE_EHRInstallation } from '../../../../../_entity/installation/ehr-installation/index.js';
export class Editor_Organization_Environments extends TS_EditableItemComponentProto {
    TypeDropDown = TS_DropDown.prepareEditable({
        adapter: SimpleListAdapter([...EHRInstallationTypes], item => _jsx(_Fragment, { children: EHRInstallation_TypeLabelMap[item.item] }))
    });
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.editMode = nextProps.editMode;
        state.ehrInstallationId = nextProps.ehrInstallationId;
        // should show save button for a new Environment on edit mode
        state.showSave = state.editable && !state.editable?.item._id && state.editMode;
        return state;
    }
    // ######################## Logic ########################
    getViewMode = () => this.state.editMode ? ViewKey_Edit : ViewKey_View;
    updateEnvironment = async (data) => {
        try {
            await this.state.editable?.updateObj(data);
        }
        catch (err) {
            this.logError(err);
        }
        finally {
            this.forceUpdate();
        }
    };
    getTabs = () => {
        const { editable, editMode } = this.state;
        const environment = editable?.item;
        const tabs = [];
        tabs.push({
            uid: 'environments-info',
            title: 'Environment Information',
            content: this.renderForm,
        });
        if (exists(environment?._id)) {
            tabs.push({
                uid: 'environments-config',
                title: `${EHRInstallation_TypeLabelMap[environment.type]} Config`,
                content: () => _jsx(Editor_EnvironmentConfig, { editable: editable, editMode: editMode })
            });
        }
        tabs.push({
            uid: 'test-patients',
            title: 'Test Patients',
            content: this.renderPatients,
        });
        return tabs;
    };
    // ######################## Render ########################
    render() {
        return _jsx(LL_H_C, { id: 'editor-organization-environments', children: this.renderTabs() });
    }
    // ######################## Render - All Tabs ########################
    renderTabs = () => {
        if (!this.state.editable)
            return;
        return _jsx(TS_Tabs, { tabs: this.getTabs() });
    };
    // ######################## Render - Environment Editor ########################
    renderForm = () => {
        if (!this.state.editable)
            return _jsx(_Fragment, {});
        const className = _className(this.state.editMode && 'edit-mode');
        return (_jsx("div", { className: "form-wrapper", children: _jsx(QScrollWrapper, { children: _jsxs(Grid, { className: className, children: [this.renderLabel(), this.renderType(), this.renderEnvDigit(), this.renderSaveButton()] }) }) }));
    };
    renderSaveButton = () => {
        const editable = this.state.editable;
        const showSave = this.state.showSave;
        if (!showSave)
            return;
        return _jsxs(_Fragment, { children: [_jsx(Button, { variant: 'primary', onClick: async () => {
                        try {
                            await editable?.save();
                            this.setState({ showSave: false });
                        }
                        catch (err) {
                            ModuleFE_Toaster.toastError(`Could not create new environment. Please validate the environment and try again.`);
                            this.logError(err);
                            this.forceUpdate();
                        }
                    }, children: "Save" }), _jsx("div", {})] });
    };
    renderLabel = () => {
        const editable = this.state.editable;
        return _jsx(TS_PropRenderer.Flat, { label: 'Label', error: editable?.hasError('label'), children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    { key: ViewKey_View, renderer: () => _jsx("div", { className: 'grid-data', children: editable?.item.label }) },
                    {
                        key: ViewKey_Edit,
                        renderer: () => _jsx(DefaultEditor_InputText, { editable: editable, prop: 'label', value: editable?.item.label, onChange: value => this.updateEnvironment({ label: value }) })
                    }
                ] }) });
    };
    // Type is inherited from EHR Installation - cannot be edited
    renderType = () => {
        const editable = this.state.editable;
        const ehrInstallationId = editable.item.ehrInstallationId;
        const ehrInstallationType = ModuleFE_EHRInstallation.cache.unique(ehrInstallationId)?.type;
        if (!ehrInstallationType)
            return;
        return _jsx(TS_PropRenderer.Flat, { label: 'Type', error: editable?.hasError('type'), children: _jsx("div", { className: 'grid-data', children: EHRInstallation_TypeLabelMap[ehrInstallationType] ?? '-' }) });
    };
    renderEnvDigit = () => {
        const editable = this.state.editable;
        return _jsx(TS_PropRenderer.Flat, { label: 'Env Digit', error: editable?.hasError('envDigit'), children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    { key: ViewKey_View, renderer: () => _jsx("div", { className: 'grid-data', children: editable?.item.envDigit ?? '-' }) },
                    {
                        key: ViewKey_Edit,
                        renderer: () => _jsx(TS_InputV2, { type: 'number', value: editable?.item.envDigit?.toString() ?? '', onChange: value => this.updateEnvironment({ envDigit: value ? Number(value) : undefined }) })
                    }
                ] }) });
    };
    // ######################## Render - Patients Editor ########################
    renderPatients = () => {
        const { editable, editMode } = this.state;
        const editableItemType = editable.item.type;
        if (!editable) {
            return _jsx(_Fragment, {});
        }
        const className = _className(editMode && 'edit-mode');
        const patients = editable.editProp('demoPatients', []);
        const addButton = (_jsxs(LL_H_C, { onClick: () => editableItemType === 'epic'
                ? patients.updateArrayAt({})
                : patients.updateArrayAt({}), style: { margin: '10px', gap: '5px', fontSize: '15px' }, children: [_jsx(ICONS.advisor_avn_add.component, {}), "Add Patient"] }));
        return (_jsx(QScrollWrapper, { children: _jsxs("div", { className: className, children: [patients?.item.map((_, index) => {
                        const editable = patients.editProp(index, {});
                        return editableItemType === 'epic' ? _jsx(Editor_EpicDemoPatient, { index: index, editable: editable, mode: this.getViewMode(), onDelete: () => patients.removeArrayItem(index) }, index) : _jsx(Editor_DeployDemoPatient, { editable: editable, mode: this.getViewMode(), index: index, onDelete: () => patients.removeArrayItem(index) }, index);
                    }), editMode && addButton] }) }));
    };
}
//# sourceMappingURL=Editor_Organization_Environments.js.map